// Utility-Funktion zur Formatierung des Datums
export const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Monate sind 0-indexiert
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
};